import { styled } from 'linaria/react';

export const UserMenuLoyaltyLink = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;
`;

export const UserMenuLoyaltyPointsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-35);

  padding: var(--space-25) var(--space-75);

  border: 1px solid var(--control-secondary);
  border-radius: 240px;

  span {
    line-height: 13px !important;
  }
`;
